import sensors from "@/api/sensors";

export default {
    state: {
        sensorDataLatest: [],
        sensorDataHistories: [],
        sensorPaging: [],
        sensorPos: []
    },
    mutations: {
        ["RETRIEVE_SENSOR_DATA_LATEST"](state, data) {
            state.sensorDataLatest = data;
        },
        ["RETRIEVE_SENSOR_DATA_HISTORIES"](state, data) {
            state.sensorDataHistories = data;
        },
        ["RETRIEVE_SENSOR_PAGING"](state, data) {
            state.sensorPaging = data;
        },
        ["RETRIEVE_SENSOR_ALL"](state, data) {
            state.sensorPos = data;
        },
    },
    actions: {
        async retrieveSensorAll(context,) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID")
                }
                let res = await sensors.showSensorAll(params);
                context.commit("RETRIEVE_SENSOR_ALL", res.data);
            } catch (error) {
                console.log(error);
            }
        },
        async retrieveSensorData(context, params) {
            try {
                params.management_id = await context.dispatch("showManagementID");
                let res = await sensors.showSensorData(params);
                return res.data;
            } catch (error) {
                console.log(error);
            }
        },
        async retrieveSensorDataLatest(context) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID")
                }
                let res = await sensors.showSensorDataLatest(params);
                context.commit("RETRIEVE_SENSOR_DATA_LATEST", res.data.data);
            } catch (error) {
                console.log(error);
            }
        },
        async retrieveSensorDataHistories(context) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID")
                }
                let res = await sensors.historyRawdataAll(params);
                context.commit("RETRIEVE_SENSOR_DATA_HISTORIES", res.data.data);
            } catch (error) {
                console.log(error);
            }
        },
        async retrieveSensors(context) {
            try {
              let params = {
                account_id: await context.dispatch("showAccountID"),
                management_id: await context.dispatch("showManagementID"),
              };
              let res = await sensors.index(params);
              return res.data.data;
            } catch (error) {
              console.log(error);
            }
          },
          async insertSensor(context, { sensor_id, sensor_name, lat, lon }) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID"),
                    sensor_id: sensor_id,
                    sensor_name: sensor_name,
                    latitude: lat,
                    longitude: lon
                }
                const res = await sensors.insert(params);
                if (res && res.status === 200) {
                    return res.data;
                }
            } catch (error) {
                console.log(error);
            }
            return { result : '9'};
        },
        async updateSensor(context, { sensor_id, sensor_name, latitude, longitude }) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID"),
                    sensor_id: sensor_id,
                    sensor_name: sensor_name,
                    latitude: latitude,
                    longitude: longitude
                }
                const res = await sensors.update(params);
                if (res && res.status === 200) {
                    return res.data;
                }
            } catch (error) {
                console.log(error);
            }
            return { result : '9'};
        },
        async deleteSensor(context, { sensor_id }) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID"),
                    sensor_id: sensor_id
                }
                await sensors.del(params);
            } catch (error) {
                console.log(error);
            }
        },
        async retrieveSensorAlert(context, { count, lastId = null, skip = 0 }) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID"),
                    count: count,
                }
                if (lastId) {
                    params.latest_alert_id = lastId;
                }
                if (skip > 0) {
                    params.skip_page = skip;
                }
                let res = await sensors.pagingAlert(params);
                return res.data.data;
            } catch (error) {
                console.log(error);
            }
        },
        async retrieveSensorRawData(context, { from, to, sensorId }) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID"),
                    from_datetime: from,
                    to_datetime: to,
                    sensor_id: sensorId
                }
                let res = await sensors.historyRawdata(params);
                return res.data;
            } catch (error) {
                console.log(error);
            }
        },
        async retrieveSensorsPaging(context) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID"),
                };
                let res = await sensors.index(params);
                context.commit("RETRIEVE_SENSOR_PAGING", res.data.data);
                return res.data.data;
            } catch (error) {
              console.log(error);
            }
          },
    },
    getters: {
        getSensorDataLatest(state) {
            return state.sensorDataLatest;
        },
        getSensorDataHistories(state) {
            return state.sensorDataHistories;
        },
        getSensorPaging(state) {
            return state.sensorPaging;
        },
        getSensorPos(state) {
            return state.sensorPos;
        },
    }
};
